import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";

const TimelineData = [
    {
        id: "1",
        title: "Visual Designer",
        description: "Iconos, Cards , Layouts, logo. ",
    },
    {
        id: "2",
        title: "Motion Designer",
        description: "Transiciones, animaciones.",
    },
    {
        id: "3",
        title: "Ux Enginer",
        description: "Html, Css, Js, React, Php ",
    },
    {
        id: "4",
        title: "Ux Research",
        description: "Test, Estudio de usuario",
    },
]

const TimelineWeb = ({classVar}) => {
    return (
        <div className="timeline-style-two bg-color-blackest">
            <div className="row row--0">
                {/* Start Single Progress */}
                {TimelineData.map((data , index) =>(
                    <div className={`col-lg-3 col-md-3 rn-timeline-single ${classVar}`} key={index}>
                        <div className="rn-timeline">
                           
                                <h6 className="title">{data.title}</h6>
                            <div className="progress-line">
                                <div className="line-inner"></div>
                            </div>
                            <div className="progress-dot">
                                <div className="dot-level">
                                    <div className="dot-inner"></div>
                                </div>
                            </div>
                       
                                <p className="description">{data.description}</p>
                        </div>
                    </div>
                ))}
                {/* End Single Progress */}
            </div>
        </div>
    )
}
export default TimelineWeb;
